import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import HealthcareNavigationPage from '@/components/pages/services/healthcareNavigation';

const ProtectedHealthcareNavigationPage = withAuthenticationRequired(
  HealthcareNavigationPage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/services/healthcareNavigation')({
  head: () => ({
    meta: [
      {
        title: `Health Navigation Platform | ${activeConfig.branding.appName}`,
      },
    ],
  }),
  component: ProtectedHealthcareNavigationPage,
});
